module.exports = __webpack_public_path__ + "static/media/shopping-cart-solid.757b71f9.svg";